import { useEffect, useRef, useState } from 'react'
import KeepAlive from 'react-activation'
import { useLocation } from 'react-router-dom'
import { SActionBtn, SDrawer, SLowcodeList, STableActions } from 'shj-components'
import {
  getRegionLists,
  dispatchMnrDelete,
  getDispatchMnrPage,
  addDispatchStore,
  getBizOpTypeEnum,
  updateDispatchStore,
  saveDispatchUser,
  getAllCompanyMrn,
  dispatchMnrUpdateById,
} from '@/services/customerServices'
import { httpOrgList } from '@/services/homeService.ts'
import { useSetState } from 'ahooks'
import { message, Switch } from 'antd'
import { config } from './config'
import { AddOrEditForm } from './addOrEdit'
const StoreManagement: React.FC = () => {
  const [state, setState] = useSetState({
    treeData: [], // 左侧树形结构数据
    companyList: [], // 门店
    regionList: [], // 门店
    BizOpTypeEnumList: [], //需求标签
  })
  const [drawerVisible, setDrawerVisible] = useState(false)
  const [editData, setEditData] = useState(null)

  const listRef = useRef<any>()
  const fetchList = values => {
    const { current, pageSize, ...rest } = values
    rest.query.searchFlag = true
    return new Promise(async (resolve, reject) => {
      try {
        let data = await getDispatchMnrPage(current, pageSize, rest.query)
        resolve(data)
      } catch (err) {
        reject({ success: false })
      }
    })
  }
  //   右侧下拉选项加载
  const getOptions = async () => {
    const companyList: any = await httpOrgList({})
    const regionList = await getRegionLists()
    const BizOpTypeEnumList: any = await getBizOpTypeEnum()
    setState({ companyList, regionList, BizOpTypeEnumList })
    return Promise.resolve({ companyList, regionList, BizOpTypeEnumList })
  }
  // 右侧表格事件：
  // 新增
  const onAdd = async () => {
    setEditData(null)
    setDrawerVisible(true)
  }
  // 刷新
  const reloadFn = () => {
    listRef.current?.reload()
  }

  //  表格事件: 编辑
  const onEdit = data => {
    setEditData(data)
    setDrawerVisible(true)
  }
  //  抽屉事件: 保存
  const onSubmit = async val => {
    const companyMrn = await getAllCompanyMrn({})
    saveDispatchUser({
      ...val,
      userName: companyMrn.filter(item => item.ucenterUserId === val.dispatchUserId)[0].userName,
    }).then(() => {
      message.success('操作成功')
      setDrawerVisible(false)
      reloadFn()
    })
  }
  // 右侧表格配置
  const extensions = {
    request: { fetchList, getOptions },
    events: {
      onAdd,
    },
    customRender: {
      actionRender(_, record: Record<string, any>) {
        return (
          <STableActions>
            <SActionBtn onClick={() => onEdit(record)}>编辑</SActionBtn>
          </STableActions>
        )
      },
      enableRender(_, record: Record<string, any>) {
        return (
          <Switch
            checkedChildren="启用"
            unCheckedChildren="停用"
            checked={record.enable ? true : false}
            onChange={(e)=>{
              dispatchMnrUpdateById({
                id: record.id,
                enable: e,
              }).then(() => {
                message.success('操作成功')
                reloadFn()
              })
            }}
          />
        )
      },
    },
  }
  return (
    <div>
      {/* 右侧数据表格 */}
      <div>
        <SLowcodeList ref={listRef} searchMode="group" config={config} {...extensions} />
      </div>
      {/* 新增弹出抽屉层 */}
      <SDrawer
        title={'编辑分配人'}
        width="500"
        open={drawerVisible}
        onClose={() => setDrawerVisible(false)}
        onSubmit={onSubmit}
        destroyOnClose
      >
        <AddOrEditForm editData={editData} state={state} />
      </SDrawer>
    </div>
  )
}

export default props => {
  return <StoreManagement {...props} />
}
